import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './components/LandingPage';
import AlbumPreview from './pages/AlbumPreview';
import FilmMusic from './pages/FilmMusic';
import Reviews from './pages/Reviews';
import Gallery from './pages/Gallery';
import Biography from './pages/Biography';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/album-preview" element={<AlbumPreview />} />
          <Route path="/film-music" element={<FilmMusic />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/biography" element={<Biography />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
